import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { subscriptionsMigrationsListColumns } from "./constants";
import { jdsTableStyles } from "../../components/jds/tableStyles";
import { JdsPagination } from "../../components/jds/JdsPagination";
import { JdsButton } from "../../components/jds/JdsButton";
import { JdsSearchInput } from "../../components/jds/JdsSearchInput";
import { PlusIcon } from "../../components/jds/icons";
import "../../components/jds/jds.css";

const subHeaderStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "var(--space-8)",
  width: "100%",
};

export const SubscriptionMigration = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [filter, setFilter] = useState("");

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div style={subHeaderStyle}>
        <JdsSearchInput
          id="search"
          placeholder="Filtro"
          filterText={filter}
          onFilter={e => setFilter(e.target.value)}
          onClear={() => setFilter("")}
        />
        <Link to="/subscription_migration/add">
          <JdsButton>
            Nova migração
            <PlusIcon />
          </JdsButton>
        </Link>
      </div>
    );
  }, [filter]);

  const handleChangeRowsPerPageChange = (rowsPerPage) => {
    setPage(1);
    setPerPage(rowsPerPage);
  };
  
  const handlePageChange = (page) => {
    setPage(page);
  };

  useEffect(() => {
    const loadMigrations = async () => {
      setIsLoading(true);
      try {
        const BASE_URL = `${process.env.REACT_APP_API_URL}/subscription/schedule-migration/all`;
        const response = await axios.get(`${BASE_URL}?page=${page}&per_page=${perPage}&filter=${filter}`);

        if (!response.data.success) {
          toast.error("Houve um erro inesperado ao carregar as migrações. Tente novamente.");
          return;
        }
        setData(response.data.data.rows);
        setTotalRows(response.data.data.count);
      } catch (error) {
        toast.error("Tivemos um problema ao carregar as migrações.");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    loadMigrations();
  }, [filter, perPage, page]);

  return (
    <div className="jds-scope">
      <h1 className="jds-title-lg">Migração de planos</h1>
      <p className="text-muted mb-10">Listagem das migrações pendentes</p>

      <div className="jds-card jds-card--flush">
        <div style={{ overflowX: "auto", width: "100%" }}>
          <DataTable
            columns={subscriptionsMigrationsListColumns}
            data={data}
            customStyles={jdsTableStyles}
            progressPending={isLoading}
            pagination
            perPage={perPage}
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handleChangeRowsPerPageChange}
            onChangePage={handlePageChange}
            paginationComponent={JdsPagination}
            subHeader
            subHeaderAlign="left"
            subHeaderComponent={subHeaderComponentMemo}
            responsive={false}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};
